<div class="client-attachments">
  @if (loading) {
    <div class="d-flex w-100 justify-content-center p-3">
      <app-loader />
    </div>
  }

  @if (!loading) {
    @if (!saving) {
      <div class="mb-4">
        <app-upload-file type="clientAttachments"
          [btnCopy]="'DASHBOARD.clientAttachments.upload' | translate"
          [titleCopy]="'DASHBOARD.clientAttachments.drag' | translate"
          [descriptionCopy]="'DASHBOARD.clientAttachments.fileTypeSize' | translate: { max: maxSizeMb }"
          (complete)="onUploadComplete($event)"
         />
      </div>
    }
    @if (saving) {
      <div class="d-flex w-100 justify-content-center p-3">
        <app-loader />
      </div>
    }
    @if (!daysWithAttachments?.length) {
      <p class="text-center text-secondary text-small">
        {{ 'DASHBOARD.clientAttachments.noAttachments' | translate }}
      </p>
    }
    @for (day of daysWithAttachments; track day) {
      <div>
        <p class="text-secondary text-small text-bold mb-2 mt-3">{{ day.createdAt | date: 'fullDate' }}</p>
        <div class="attachments-grid">
          @for (attachment of day.attachments; track attachment) {
            <div
              class="attachment-card"
              [ngClass]="{ image: isImage(attachment) }"
              (click)="openFilePreview(attachment)"
              >
              @if (isImage(attachment)) {
                <div
                  class="attachment-thumb"
                  [style.backgroundImage]="'url(' + attachment.fileUrl + ')'"
                ></div>
              }
              @if (!isImage(attachment)) {
                <div class="attachment-doc">
                  <p class="text-primary text-bold text-small mb-0 truncate">{{ attachment.fileName }}</p>
                  <p class="text-secondary text-small mb-0">
                    {{ isPdf(attachment) ? 'PDF' : ('DASHBOARD.clientAttachments.document' | translate) }}
                  </p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>
